import { render, staticRenderFns } from "./ReviewModifyCommunication.vue?vue&type=template&id=4cfa360c"
import script from "./ReviewModifyCommunication.vue?vue&type=script&lang=js"
export * from "./ReviewModifyCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports